import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/ReserveTalent'

const ReserveTalent = {
  PageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PageData`,
      data
    })
  },
  SyncReserveTalent(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SyncReserveTalent`,
      data
    })
  },
  List(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/List`,
      data
    })
  },
  Create(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Create`,
      data
    })
  },
  Detail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}`,
      params
    })
  },
  Modify(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Modify`,
      data
    })
  },
  BatchNewByPublicTalent(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/BatchNewByPublicTalent`,
      data
    })
  },
  Import(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Import`,
      data
    })
  },
  Delete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Delete`,
      data
    })
  }
}

export default ReserveTalent
